module.exports = __webpack_public_path__ + "static/04-562bfeb157a9c28c2c5f14614563c341.png";